import { Screen } from "@/components/site/Screen";
import { NavSpots } from "@/components/site/ArtPage";
import { usePublishedPhotos } from "@/lib/hooks";
import { assetUrl } from "@/lib/api";

const FRAMES = [
  { slot: "about-1", style: { left: "5.3%", top: "15.1%", width: "22%", height: "20.5%", transform: "rotate(-11deg)" } },
  { slot: "about-2", style: { left: "75.2%", top: "19.1%", width: "17.3%", height: "19%", transform: "rotate(7deg)" } },
];

export const AboutPage = ({ go }) => {
  const photos = usePublishedPhotos();
  return (
    <section aria-label="Behind the Crown">
      <Screen page="about">
        <NavSpots page="about" go={go} />
        {FRAMES.map(({ slot, style }) =>
          photos[slot] ? (
            <div key={slot} className="about-photo" style={style} data-testid={`about-photo-${slot}`}>
              <img src={assetUrl(photos[slot])} alt="Smiless, Behind the Crown" />
            </div>
          ) : null
        )}
      </Screen>
    </section>
  );
};
